import ChinhSachBaoMat from "components/Policy/ChinhSachBaoMat"

export default function Security() {
  return (
    <section className="max-w-screen-sm m-auto md:mt-4 p-4">
      <ChinhSachBaoMat />
    </section>
  )
}
